// import {
//     type
// } from "os";

export default function checkoutDeliveryDetailsCtrl($scope, $http, $rootScope) {
    $scope.active_service = 0;
    $scope.shipping_services = {};
    $scope.ship_same = 0;
    $scope.bill_form = {};
    $scope.bill_form.regions = {};
    $scope.ship_form = {};
    $scope.ship_form.regions = {};
    $scope.shipping_services = [];
    $scope.shipping_services_loading = false;
    $scope.user_addresses = [];

    $scope.validationOptions = {
        rules: {
            email: {
                required: true,
                email: true
            }
        },
        messages: {
            bill_code: {
                required: "required"
            },
            ship_code: {
                required: "required"
            },
        },
        ignore: [],
        errorPlacement: function (error, element) {
            if ($(element).is(":radio")) {
                var hidELement = $(element).parent().parent().parent();
                error.appendTo(hidELement);

            } else if ($(element).is("select")) {

                var hidELement = $(element).parent().find('span.select2.select2-container');
                error.insertAfter(hidELement);

            } else if ($(element).is(":hidden")) {
                var hidELement = $(element).parent();
                error.insertAfter(hidELement);
            } else {
                error.insertAfter(element);
            }
        },
        highlight: function (element, errorClass, validClass) {
            if ($(element).is(":hidden")) {
                $(element)
                    .parent()
                    .addClass(errorClass)
                    .removeClass(validClass);
            } else {
                $(element)
                    .addClass(errorClass)
                    .removeClass(validClass);

                $(element)
                    .prev()
                    .addClass('top-error');

                $(element)
                    .parent()
                    .addClass('error')
            }
        },
        unhighlight: function (element, errorClass, validClass) {

            if ($(element).is(":hidden")) {
                $(element)
                    .parent()
                    .removeClass(errorClass)
                    .addClass(validClass);
            } else {
                $(element)
                    .removeClass(errorClass)
                    .addClass(validClass);

                $(element)
                    .prev()
                    .removeClass('top-error');

                $(element)
                    .parent()
                    .removeClass('error')
            }
        }
    };

    $scope.showShippings = function () {
        var _show = false;
        if ($scope.ship_same == 1) {
            _show =
                $scope.bill_form.country > 0 && !$scope.shipping_services_loading && $scope.shipping_services.length > 0;
        } else {
            _show =
                $scope.ship_form.country > 0 && !$scope.shipping_services_loading && $scope.shipping_services.length > 0;
        }
        return _show;
    };

    $scope.getRegions = function (type, _region) {
        var _country = 0;
        if (type == 1) {
            $scope.bill_form.region = null;
            _country = $scope.bill_form.country;
        } else {
            $scope.ship_form.region = null;
            _country = $scope.ship_form.country;
        }
        if (typeof _country === 'undefined') {
            return false;
        }

        $http({
            method: "GET",
            url: "/"+window.Laravel.code+"/checkout/delivery-details/get-all-areas/" + _country,
        }).then(function success(response) {
            var data = response.data;
            if (type == 1) {
                $scope.bill_form.regions = data;
                $scope.bill_form.region = _region;
                setTimeout(() => {
                    $('#billing_region_dd').change();
                    $scope.saveDeliveryDetailsForm.validate();
                }, 200);
            } else {
                $scope.ship_form.regions = data;
                $scope.ship_form.region = _region;
                setTimeout(() => {
                    $('#shipping_region_dd').change();
                    $scope.saveDeliveryDetailsForm.validate();
                }, 200);
            }
        }, function error(response) {
            var data = response.data;
        });
    };

    $scope.getShipping = function (event) {
        if (!$scope.saveDeliveryDetailsForm.validate()) {
            console.log('not valid');
            event.preventDefault();
            return false;
        }
        $rootScope.showOverlay('container-wrap');
        event.preventDefault();
        $scope.shipping_services = [];
        $scope.shipping_services_loading = true;
        $('#services-wrap').fadeOut();
        var params = {};
        if ($scope.ship_same == 1) {
            params = $scope.bill_form;
            params.fname = $scope.bill_form.fname;
            params.lname = $scope.bill_form.lname;
            params.phone = $scope.bill_form.phone;
            params.country_id = $scope.bill_form.country;
            params.region_id = $scope.bill_form.region;
            params.code = $scope.bill_form.code;
            params.city = $scope.bill_form.city;
            params.address = $scope.bill_form.address;
        } else {
            params = $scope.ship_form;
            params.fname = $scope.ship_form.fname;
            params.lname = $scope.ship_form.lname;
            params.phone = $scope.ship_form.phone;
            params.country_id = $scope.ship_form.country;
            params.region_id = $scope.ship_form.region;
            params.code = $scope.ship_form.code;
            params.city = $scope.ship_form.city;
            params.address = $scope.ship_form.address;
        }

        if (params.country > 0) {
            $http({
                method: "POST",
                url: "/"+window.Laravel.code+"/checkout/delivery-details/calculate-shippings",
                data: $rootScope.params(params),
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
            }).then(function success(response) {
                var data = response.data;
                $scope.shipping_services_loading = false;
                $scope.shipping_services_errors = data.errors
                $scope.shipping_services = data.items;
                // $rootScope.hideOverlay('container-wrap');
                console.log('getShipping: ', data);
                if (data.hasOwnProperty('errors') && data.errors.length > 0) {
                    $rootScope.hideOverlay('container-wrap');
                } else {
                    $scope.setService(data.items[0]);
                    setTimeout(function () {
                        angular.element('#nextStepButton').click();
                    }, 1000);

                }

            }, function error(response) {
                var data = response.data;
                $rootScope.hideOverlay('container-wrap');
                console.log('getShipping: ', data);
            });
        }
    };

    $scope.setService = function (service) {
        $scope.active_service = service;
    }

    $scope.saveDeliveryDetails = function (event) {
        if (!$scope.saveDeliveryDetailsForm.validate()) {
            event.preventDefault();
        } else {
            $rootScope.showOverlay('container-wrap');
        }
    }

    $scope.init = function () {
        setTimeout(function () {
            $('#billing_country_dd').change();
            $('#billing_region_dd').change();

            $('#shipping_country_dd').change();
            $('#shipping_region_dd').change();
        }, 1000)
    }

    $scope.init();

    /**
     * Watchers 
     */

    $scope.$watch("ship_same", function (newValue, oldValue) {
        $scope.shipping_services = [];
    });

    $scope.$watch("bill_form_selected", function (newValue, oldValue) {
        if (typeof newValue !== 'undefined') {
            if (newValue == 0) {
                $scope.bill_form.address = '';
                $scope.bill_form.apt = '';
                $scope.bill_form.city = '';
                $scope.bill_form.code = '';
                $scope.bill_form.country = 0;
                $scope.bill_form.region = 0;
                $scope.bill_form.regions = [];
            } else {
                var tmp = angular.copy($scope.user_addresses[newValue]);
                $scope.bill_form.address = tmp.address;
                $scope.bill_form.apt = tmp.apt;
                $scope.bill_form.city = tmp.city;
                $scope.bill_form.code = tmp.code;
                $scope.bill_form.country = tmp.country;
                $scope.bill_form.country_name = tmp.country_name;
                $scope.bill_form.email = tmp.email;
                $scope.bill_form.fname = tmp.fname;
                $scope.bill_form.id = tmp.id;
                $scope.bill_form.lname = tmp.lname;
                if(tmp.phone!='') $scope.bill_form.phone = tmp.phone;
                $scope.bill_form.region = tmp.region;
                $scope.bill_form.region_name = tmp.region_name;
                $scope.bill_form.regions = tmp.regions;
                // $scope.bill_form = tmp;
                setTimeout(function () {
                    $scope.saveDeliveryDetailsForm.validate();
                }, 1)
            }
        }
    });

    // Billing Info
    $scope.$watchCollection("bill_form", function (newValue, oldValue) {
        $scope.shipping_services = [];
    });

    $scope.$watch("bill_form.country", function (newValue, oldValue) {
        if (typeof newValue !== 'undefined') {
            var tmpregion = angular.copy($scope.bill_form.region);
            if (newValue > 0) $scope.saveDeliveryDetailsForm.validate();
            setTimeout(function () {
                $('#billing_country_dd').change();
                $scope.getRegions(1, tmpregion);
                // $scope.bill_form.region = tmpregion;
            }, 500);
        }
    });

    $scope.$watch("bill_form.region", function (newValue, oldValue) {
        if (typeof newValue !== 'undefined') {
            if (newValue > 0) $scope.saveDeliveryDetailsForm.validate();
        }
    });

    // Shipping Info
    $scope.$watch("ship_form_selected", function (newValue, oldValue) {
        if (typeof newValue !== 'undefined' && $scope.ship_same == 0) {
            if (newValue == 0) {
                $scope.ship_form.address = '';
                $scope.ship_form.apt = '';
                $scope.ship_form.city = '';
                $scope.ship_form.code = '';
                $scope.ship_form.country = 0;
                $scope.ship_form.region = 0;
                $scope.ship_form.regions = [];
            } else {
                var tmp = angular.copy($scope.user_addresses[newValue]);
                $scope.ship_form = tmp;
                setTimeout(function () {
                    $scope.saveDeliveryDetailsForm.validate();
                }, 1)
            }
        }
    });

    $scope.$watchCollection("ship_form", function (newValue, oldValue) {
        $scope.shipping_services = [];
    });

    $scope.$watch("ship_form.country", function (newValue, oldValue) {
        if (typeof newValue !== 'undefined' && $scope.ship_same == 0) {
            var tmpregion = angular.copy($scope.ship_form.region);
            if (newValue > 0) $scope.saveDeliveryDetailsForm.validate();
            setTimeout(function () {
                $('#shipping_country_dd').change();
                $scope.getRegions(2, tmpregion);
                // $scope.ship_form.region = tmpregion;
            }, 600);
        }
    });

    $scope.$watch("ship_form.region", function (newValue, oldValue) {
        if (typeof newValue !== 'undefined' && $scope.ship_same == 0) {
            if (newValue > 0) $scope.saveDeliveryDetailsForm.validate();
        }
    });
}

checkoutDeliveryDetailsCtrl.$inject = ['$scope', '$http', '$rootScope'];